module.exports = __webpack_public_path__ + "static/media/1POLICY17.07ba1236.jpg";